export const TheadAccordion = ["Editables", "Autorizados"];
